module.exports = __webpack_public_path__ + "static/variable-universal-life-insurance-hero.f5c70b72.webp";